import React, { useState } from "react";
import "./AccountClosureForm.css";
import accountclosure from "../../../Images/account-closure/closure-form-img.png";
import accountClosureFormPdf from "./../../../pdf/Common_Closure_Form.pdf";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from "react-bootstrap";
import { userSelector, clearState, fetchUserBytoken } from '../../features/User/UserSlice';

function AccountClosureForm() {

  const [file, setfile] = useState('');
  const [filename, setfilename] = useState('');
  const { email } = useSelector(userSelector);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  const handleChange = (event) => {
    setfile(event.target.files[0]);
    setfilename(event.target.files[0].name);
  }
  const handleClosePopup = () => {
    window.location.href = "/";
  }

  const clicksubmitform = async () => {

    var from_data_form = {
      "uploaded_file": filename,
      "email_id": email,
      "upd_file": true
      }
      const formData = new FormData();
      formData.append("formFile", file);
      formData.append("fileName", filename);
      try {
          const res = await axios.post("/api/Login/file", formData);

      } catch (ex) {

      }

    axios.post("/api/Login/AccountClosure", from_data_form)
      .then(function (response) {
        if (response.data.success === false) {
          return false;
        }
      })
      .catch(function (response) {

      });
      handleShow();
  };

  return (
    <>
      <div className="AccountClosureForm_page">
        <section className="our-story-block disclaimer">
          <Container>
            <div className="our-story-inner arrow-main">
              <h2 className="text-center">Account Closure Form </h2>
              <div className="AccountClosureFormdownload_grid">
                <div className="row justify-content-center">
                  <div className="col-sm-6">
                    <div className="AccountClosureFormdownload_group">
                      <h3>Step 1</h3>
                      <div className="AccountClosureFormdownload_panel">
                        <div className="AccountClosureFormdownload_img">
                          <img src={accountclosure} alt={accountclosure} className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="AccountClosureFormdownload_content">
                          <h4> Account Closure Form</h4>
                          <a href={accountClosureFormPdf} download className="accclosureform_downloadbtn">Download </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="AccountClosureFormdownload_group">
                      <h3>Step 2</h3>
                      <div className="AccountClosureFormupload_panel">
                        <h4>Fill and upload scan copy of Downloaded Form</h4>
                        <div className="form-group">
                          <div className="AccountClosure_uploadfile">
                            <div className="custom-file">
                              <input type="file" className="custom-file-input" id="customFile" accept=".pdf,.doc,.docx" onChange={handleChange}></input>
                              <label className="custom-file-label" htmlFor="customFile">Choose file</label>
                              <div className="fileName">{filename}</div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group text-center">
                          <button type="submit" className="btn btn-lg Login-Button" onClick={() => clicksubmitform()}>Submit</button>
                        </div>
                        <Modal className="success-modal" show={show} >
                          <div>
                            <Modal.Body className="textsucess"> Successfully Submitted.!</Modal.Body>
                            <button className="btnClose" onClick={handleClosePopup}>Close</button>
                          </div>
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </>
  );
}
export default AccountClosureForm;
